import { Form, Input } from "decorator-form";
import InputType from "common/form/InputType";
import { knowledgeBaseIdSelect } from "panels/kb/util/widget";
import { ID } from "common/entities/IEntity";

@Form({ title: "Refine Category View Config" })
export class RefineTagPanelConfig {
	@Input({ type: InputType.UNIT, title: "Font Size" })
	public fontSize: string="16px";

	@Input({ type: InputType.FONT_WEIGHT, title: "Font Weight" })
	public fontWeight: string | number;

	@Input({type: knowledgeBaseIdSelect, title: "Knowledge Base"})
	public knowledgeBaseId: ID;

	@Input({ type: InputType.CHECKBOX, title: "Sort alphabetically" })
	public sortCategories?: boolean;

}



// WEBPACK FOOTER //
// ./src/panels/knowledgebase/refineArticle/RefineTagPanelConfig.ts